import PropTypes from 'prop-types';

export const inputDefaultProps = {
  align: undefined,
  alignSelf: undefined,
  clearable: undefined,
  disabled: undefined,
  readonly: undefined, // This is needed to support metaform in its current form. Do not bring to facet-core
  error: undefined,
  flex: undefined,
  flexGrow: undefined,
  min: undefined,
  max: undefined,
  flexShrink: undefined,
  fullWidth: undefined,
  helperTextValue: undefined,
  label: undefined,
  multiple: undefined,
  name: undefined,
  onBlur: undefined,
  onFocus: undefined,
  onChange: undefined,
  placeholder: undefined,
  required: undefined,
  value: undefined,
  valueLabelDisplay: undefined,
  size: undefined,
  textSize: undefined,
  roundToDollar: undefined,
  labelPlacement: undefined,
  iconLocation: undefined,
};

const optionShape = PropTypes.shape({
  id: PropTypes.string,
  prompt: PropTypes.string,
});

export const inputPropTypes = {
  alignSelf: PropTypes.oneOf(['flex-start', 'center', 'flex-end', undefined]),
  align: PropTypes.oneOf(['start', 'center', 'end', 'justify', undefined]),
  clearable: PropTypes.bool,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  error: PropTypes.bool,
  flex: PropTypes.number,
  flexGrow: PropTypes.number,
  flexShrink: PropTypes.number,
  fullWidth: PropTypes.bool,
  helperTextValue: PropTypes.string,
  label: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  multiple: PropTypes.bool,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  option: PropTypes.objectOf(optionShape),
  options: PropTypes.arrayOf(optionShape),
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'lg']),
  textSize: PropTypes.oneOf(['sm', 'md', 'lg']),
  textColor: PropTypes.oneOf(['textPrimary', 'textSecondary', 'textAttention', 'textDisabled']),
  value: PropTypes.string,
  valueLabelDisplay: PropTypes.oneOf(['auto', 'off']),
  roundToDollar: PropTypes.bool,
  labelPlacement: PropTypes.oneOf(['inset', 'left']),
  iconPosition: PropTypes.oneOf(['left', 'right']),
};
